/** @return {object} - get info of checkout */
const getCheckoutInfoRequired = state => {
  return state.checkout.required.infos;
};
/** @return {object} - get info of checkout */
const getCheckoutInfoPostalCode = state => {
  return state.checkout.required.infos.postalcode;
};

/** @return {object} - get optional info of checkout */
const getCheckoutInfoOptional = state => {
  return state.checkout.optional.infos;
};

/** @return {object} - get info of checkout */
const getCheckoutPercentFill = state => {
  return state.checkout.fillPercent;
};

const getCheckoutRentingInfoRequired = state => {
    return state.checkout.required_renting.infos;
};

export default {
  getCheckoutInfoRequired,
  getCheckoutPercentFill,
  getCheckoutInfoOptional,
  getCheckoutInfoPostalCode,
  getCheckoutRentingInfoRequired
};
